export interface GradientStop {
  pos: number;   // 0–1
  color: string; // hex, e.g. "#FF8863"
}

function hexToRgb(hex: string): [number, number, number] {
  const value = parseInt(hex.slice(1), 16);
  const r = (value >> 16) & 255;
  const g = (value >> 8) & 255;
  const b = value & 255;
  return [r, g, b];
}

function rgbToHex([r, g, b]: [number, number, number]): string {
  const toHex = (x: number) => x.toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

function lerpColor(c1: [number, number, number], c2: [number, number, number], t: number): string {
  const r = Math.round(lerp(c1[0], c2[0], t));
  const g = Math.round(lerp(c1[1], c2[1], t));
  const b = Math.round(lerp(c1[2], c2[2], t));
  return rgbToHex([r, g, b]);
}

/**
 * Get color for a given position in PERCENT (0–100) along the gradient.
 */
export function getGradientColorAtPercent(percent: number, gradient: GradientStop[]): string {
  // clamp
  const t = Math.max(0, Math.min(100, percent)) / 100;

  for (let i = 0; i < gradient.length - 1; i++) {
    const s1 = gradient[i];
    const s2 = gradient[i + 1];

    if (t >= s1.pos && t <= s2.pos) {
      const localT = (t - s1.pos) / (s2.pos - s1.pos);
      return lerpColor(hexToRgb(s1.color), hexToRgb(s2.color), localT);
    }
  }

  return gradient[gradient.length - 1].color;
}
